import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import ListPasien from "@/services/ListPasien";

interface NowCalling {
  pasienRm: string;
  registerId: number;
  qNum: number;
  qText: string;
}

export interface DokterKunjungan {
  c_doc_id: string;
  id: number | null;
  nama: string;
}

@Module({ dynamic: true, namespaced: true, store, name: "list-pasien-ralan" })
class ListPasienRalan extends VuexModule {
  list = [];
  dokter: Array<DokterKunjungan> | null = null;
  _loading = false;
  activeRow = null;
  inputPeriksaActiveRow = false;

  paramTgl = null;
  paramUnitId = null;
  paramDokterId = null;
  paramStatus = "-1";
  /** Unit tempat paramStatus dipilih — filter status IGD tidak boleh terbawa ke poli lain. */
  paramStatusUnitId = null;

  filter: {
    qMode: "regular" | "fastrack";
  } = null;
  qMode: "regular" | "fastrack" = "regular";
  qSort = false;

  nowCalling: NowCalling = null;

  @Mutation
  CLEAR_FILTER() {
    this.paramTgl = null;
    this.paramUnitId = null;
    this.paramDokterId = null;
    this.paramStatus = "-1";
    this.paramStatusUnitId = null;
  }

  @Mutation
  SET_PARAM_TGL(val) {
    this.paramTgl = val;
  }

  @Mutation
  SET_PARAM_UNIT(val) {
    this.paramUnitId = val;
  }

  @Mutation
  SET_PARAM_DOKTER(val) {
    this.paramDokterId = val;
  }

  @Mutation
  SET_PARAM_STATUS(val) {
    this.paramStatus = val;
  }

  @Mutation
  SET_PARAM_STATUS_UNIT(val) {
    this.paramStatusUnitId = val;
  }

  @Mutation
  SET_LOADING(val) {
    this._loading = val;
  }

  @Mutation
  SET_LIST(list: Array<any>) {
    this.list = list;
  }

  @Mutation
  SET_DOKTER(dokter: Array<DokterKunjungan> | null) {
    this.dokter = dokter;
  }

  @Action({ rawError: true })
  setActiveRowFromPasienRm(pasienRm) {
    this.CLEAR_ACTIVE_ROW();

    this.SET_ACTIVE_ROW(this.list.find(item => item.rm == pasienRm));
  }

  @Action({ rawError: true })
  clearList() {
    this.CLEAR_LIST();
    this.CLEAR_ACTIVE_ROW();
  }

  @Mutation
  CLEAR_ACTIVE_ROW() {
    this.activeRow = null;
    this.inputPeriksaActiveRow = false;
  }

  @Mutation
  CLEAR_LIST() {
    this.list = [];
    this.dokter = null;
  }

  @Mutation
  SET_ACTIVE_ROW(item) {
    this.activeRow = item;
  }

  @Mutation
  SET_INPUT_PERIKSA_ACTIVE_ROW(val) {
    this.inputPeriksaActiveRow = val;
  }

  @Mutation
  SET_FILTER(filter) {
    this.filter = filter;
  }

  @Mutation
  SET_QMODE(val: "regular" | "fastrack") {
    this.qMode = val;
  }

  @Mutation
  SET_QSORT(val: boolean) {
    this.qSort = val;
  }

  @Mutation
  SET_NOWCALLING(val: NowCalling | null) {
    this.nowCalling = val;
  }

  @Action({ rawError: true })
  async getList(params): Promise<void> {
    this.SET_LOADING(true);

    const { tgl, unitId, dokterId, status } = params;

    const response = await ListPasien.getListPasienPoliklinik(
      tgl,
      unitId,
      dokterId,
      status
    ).finally(() => {
      this.SET_LOADING(false);
    });

    const list = response.status == 1 ? response.data : [];

    this.SET_LIST(list);
    this.SET_DOKTER(
      response.status == 1 && Array.isArray(response.dokter)
        ? response.dokter
        : null
    );
  }

  @Action({ rawError: true })
  getListWithoutParam() {
    return this.getList({
      tgl: this.paramTgl,
      unitId: this.paramUnitId,
      dokterId: this.paramDokterId,
      status: this.paramStatus
    });
  }

  @Action({ rawError: true })
  getListByDokter(dokterId) {
    return this.getList({
      tgl: this.paramTgl,
      unitId: this.paramUnitId,
      dokterId: dokterId,
      status: this.paramStatus
    });
  }

  @Action({ rawError: true })
  setFilter(
    filter: null | {
      qMode?: "regular" | "fastrack";
    }
  ) {
    this.SET_FILTER(filter);
  }

  @Action({ rawError: true })
  setQMode(val: "regular" | "fastrack") {
    this.SET_QMODE(val);
  }

  @Action({ rawError: true })
  setQSort(val: boolean) {
    this.SET_QSORT(val);
  }

  @Action({ rawError: true })
  setNowCalling(val: NowCalling | null) {
    this.SET_NOWCALLING(val);
  }

  @Action({ rawError: true })
  clearAll() {
    this.CLEAR_LIST();
    this.CLEAR_ACTIVE_ROW();
    this.CLEAR_FILTER();
    this.SET_NOWCALLING(null);
  }
}

export default getModule(ListPasienRalan);
